import { Link } from "react-router-dom";
import StatusBadge, { statusDescription } from "./StatusBadge";
import { formatEventDate, formatEventTimeRange } from "../utils/dateTime";

export default function EventCard({ event }) {
  const spotsLeft = Math.max(0, (event.capacity || 0) - (event.confirmedTeenCount || 0));
  const showCapacity = event.status === "CONFIRMED" || event.status === "FULL";

  return (
    <article className="card" aria-labelledby={`event-${event.eventId}-title`}>
      <StatusBadge status={event.status} />
      <h3 id={`event-${event.eventId}-title`}>
        <Link to={`/events/${event.eventId}`}>{event.title}</Link>
      </h3>
      <p>{formatEventDate(event.startAt)}</p>
      <p>{formatEventTimeRange(event.startAt, event.endAt)}</p>
      {showCapacity && (
        <p>
          {event.confirmedTeenCount} of {event.capacity} teen spots reserved
          {spotsLeft === 0 ? " \u2014 join the waitlist" : ` \u2014 ${spotsLeft} left`}
        </p>
      )}
      <p className="field-hint">{statusDescription(event.status)}</p>
      <Link className="btn btn-secondary" to={`/events/${event.eventId}`}>
        View details
      </Link>
    </article>
  );
}
